import type { TFunction } from 'i18next'

// 로그인 밖 화면은 상단 경로가 없다. 약관 이름은 바닥글 링크 문구와 같다
const PUBLIC_PAGE_TITLE_KEYS: Record<string, string> = {
    '/guide': 'pageTitle.guide',
    '/login': 'pageTitle.login',
    '/terms': 'account.terms.service',
    '/privacy': 'account.terms.privacy',
    '/location-terms': 'account.terms.location',
    '/location-privacy': 'footer.locationPrivacy'
}

/** 화면 이름 | 케얼리. 첫 화면만 소개 문구 */
export const getDocumentTitle = (t: TFunction, pathname: string, currentCrumb: string): string => {
    if (pathname === '/' || pathname === '/home') return t('pageTitle.home')
    const brand = t('app.title.carearly')
    const key = PUBLIC_PAGE_TITLE_KEYS[pathname]
    const page = key ? t(key) : currentCrumb
    return page && page !== brand ? `${page} | ${brand}` : brand
}
